// Single source of truth for the employee dashboard modules.
//
// Each module ties together the permission key (used by the router + sidebar),
// the access flag name used on the Dashboard, its route, label and accent
// colour. Dashboard, the Profile section/chart editor and (optionally) the
// sidebar can all read from here instead of re-declaring the same mapping.
//
// Note: routes are rendered by EmployeeDashboard's `sidebarLinks` array (not
// React Router routes), so `route` here is the pathname to navigate to.

export const DASHBOARD_MODULES = [
  {
    key: 'deliveryOrders',
    accessKey: 'delivery-order',
    flag: 'hasDeliveryOrderAccess',
    route: '/employee/delivery-order-new',
    label: 'Delivery Orders',
    color: '#3B82F6',
    statusSetKey: 'deliveryOrders',
  },
  {
    key: 'quotationNew',
    accessKey: 'quotation-new',
    flag: 'hasQuotationNewAccess',
    route: '/employee/quotation-new',
    label: 'Quotation New',
    color: '#8B5CF6',
    statusSetKey: 'quotationNew',
  },
  {
    key: 'tallyQuotation',
    accessKey: 'tally-quotation',
    flag: 'hasTallyQuotationAccess',
    route: '/employee/tally-quotation',
    label: 'Tally Quotations',
    color: '#22C55E',
    statusSetKey: 'tallyQuotation',
  },
  {
    key: 'tallyItems',
    accessKey: 'tally-items-management',
    flag: 'hasTallyItemsAccess',
    route: '/employee/tally-items-management',
    label: 'Tally Items Management',
    color: '#A855F7',
  },
  {
    key: 'tallyLedger',
    accessKey: 'tally-ledger-management',
    flag: 'hasTallyLedgerAccess',
    route: '/employee/tally-ledger-management',
    label: 'Tally Ledger Management',
    color: '#16A34A',
  },
  {
    key: 'visitor',
    accessKey: 'visitor-management',
    flag: 'hasVisitorAccess',
    route: '/employee/visitor-management',
    label: 'Visitor Management',
    color: '#0EA5E9',
  },
  {
    key: 'reminders',
    accessKey: 'reminders',
    flag: 'hasRemindersAccess',
    route: '/employee/reminders',
    label: 'My Reminders',
    color: '#F59E0B',
  },
];

export const MODULE_BY_KEY = Object.fromEntries(
  DASHBOARD_MODULES.map((m) => [m.key, m]),
);

// Computes the `has*Access` flags the Dashboard uses, from the domain
// dashboardAccess list and the user's role dashboardAccess list.
export const moduleAccessFlags = (dashboardAccess = [], roleDashboardAccess = []) => {
  const has = (accessKey) =>
    dashboardAccess.includes(accessKey) && roleDashboardAccess.includes(accessKey);
  return Object.fromEntries(
    DASHBOARD_MODULES.map((m) => [m.flag, has(m.accessKey)]),
  );
};

export const moduleRoute = (key) => MODULE_BY_KEY[key]?.route || '/employee/dashboard';
export const moduleLabel = (key) => MODULE_BY_KEY[key]?.label || key;
